import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-hidden rounded-lg shadow-lg ring-1 ring-gray-300 text-sm" }
const _hoisted_2 = { class: "relative grid gap-4 bg-white p-7" }
const _hoisted_3 = { class: "flex gap-1 items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-[#438F7F] text-[8px]" }, "●", -1)
const _hoisted_5 = { class: "text-gray mt-1 text-xs" }
const _hoisted_6 = { class: "flex gap-1 items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-[#E7BC66] text-[8px]" }, "●", -1)
const _hoisted_8 = { class: "text-gray mt-1 text-xs" }

import { Popover, PopoverButton, PopoverPanel } from "@headlessui/vue";
import { InformationCircleIcon as InformationCircleIconOutlined } from "@heroicons/vue/24/outline";
import { InformationCircleIcon } from "@heroicons/vue/24/solid";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitValuesPopover',
  emits: ["reportInfoClick"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const emits = __emit;

const handlePopoverClick = (isClosed: boolean) => {
  if (!isClosed) {
    emits("reportInfoClick");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Popover), { class: "relative" }, {
      default: _withCtx(({ open }) => [
        _createVNode(_unref(PopoverButton), {
          onClick: ($event: any) => (handlePopoverClick(open)),
          class: "outline-none"
        }, {
          default: _withCtx(() => [
            open
              ? (_openBlock(), _createBlock(_unref(InformationCircleIcon), {
                  key: 0,
                  class: "h-6 w-6 text-yellow ring-0"
                }))
              : (_openBlock(), _createBlock(_unref(InformationCircleIconOutlined), {
                  key: 1,
                  class: "h-6 w-6 text-yellow ring-0"
                }))
          ]),
          _: 2
        }, 1032, ["onClick"]),
        _createVNode(_Transition, {
          "enter-active-class": "transition duration-200 ease-out",
          "enter-from-class": "translate-y-1 opacity-0",
          "enter-to-class": "translate-y-0 opacity-100",
          "leave-active-class": "transition duration-150 ease-in",
          "leave-from-class": "translate-y-0 opacity-100",
          "leave-to-class": "translate-y-1 opacity-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(PopoverPanel), { class: "absolute right-0 z-10 mt-3 w-screen max-w-sm px-4 sm:px-0 lg:max-w-3xl" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_3, [
                        _hoisted_4,
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("analytics.reports.unit_values_title")), 1)
                      ]),
                      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("analytics.reports.unit_values_description")), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("analytics.reports.working_hours_title")), 1)
                      ]),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(t)("analytics.reports.working_hours_description")), 1)
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})